import { Mail } from "lucide-react";

/**
 * Blocco contatti mostrato in fondo a ogni pagina.
 * Variante `dark` per le schermate a tema scuro (es. esame).
 */
export const ContactFooter = ({ dark = false, className = "" }) => (
  <div className={`mt-8 ${className}`} data-testid="contact-footer">
    <a
      href="mailto:info@misteracademy.it"
      data-testid="contact-footer-email-link"
      className={`inline-flex items-center gap-3 rounded-2xl border px-4 py-3 transition-colors duration-200 ${
        dark
          ? "border-white/15 bg-white/5 hover:border-white/40"
          : "border-[color:var(--hairline)] bg-[color:var(--bg-subtle)] hover:border-[color:var(--ink)]"
      }`}
    >
      <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[color:var(--volt)] shrink-0" aria-hidden="true">
        <Mail className="w-4 h-4 text-[color:var(--ink)]" strokeWidth={2.5} />
      </span>
      <span className="text-left min-w-0">
        <span className={`block text-[10px] uppercase tracking-[0.14em] font-bold ${dark ? "text-white/50" : "text-[color:var(--text-2)]"}`}>
          Per comunicazioni o info
        </span>
        <span className={`block text-sm font-extrabold truncate ${dark ? "text-white" : "text-[color:var(--ink)]"}`}>
          info@misteracademy.it
        </span>
      </span>
    </a>
  </div>
);
